import { mapActions, mapGetters } from "vuex";

export default {
    name: "CopyButton",
    props: {
        synonym: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters("Login", ["user"])
    },
    methods: {
        ...mapActions("ThesaurusFilter", ["copySynonym"]),
        copy(synonym) {
            const slug = synonym.headword || synonym.slug;
            const { relationId } = synonym;
            this.copyTextToClipboard({ slug, relationId });
            this.$ga.event({
                eventCategory: "Copy",
                eventAction: "Copied"
            });
        },
        fallbackCopyTextToClipboard(synonym) {
            var textArea = document.createElement("textarea");
            textArea.value = synonym.slug;

            // Avoid scrolling to bottom
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.position = "fixed";

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                document.execCommand("copy") ? this.copySynonym(synonym) : null;
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error("Oops, unable to copy", err);
            }

            document.body.removeChild(textArea);
        },
        copyTextToClipboard(synonym) {
            if (!navigator.clipboard) {
                this.fallbackCopyTextToClipboard(synonym);
                return;
            }
            navigator.clipboard.writeText(synonym.slug).then(
                () => {
                    this.copySynonym(synonym);
                },
                err => {
                    // eslint-disable-next-line no-console
                    console.error("Could not copy text: ", err);
                }
            );
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/CopyButton/CopyButton.js